/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ParticipantLite } from './participantLite';

export interface DryRunOut {
  participant: ParticipantLite;
  data_class: string;
  retention_recording_until: string | null;
  retention_transcript_until: string | null;
  consent_state: string;
  write_back_blocked: boolean;
  block_reason: string | null;
  caller_keeps_access: boolean;
}
